import CustomJs from './CustomJs';

export default CustomJs;
